/**
 * Click-to-quote bus. The whitespace grid publishes "quote this" requests; the
 * calculator subscribes. Kept outside React state on purpose: the two
 * components sit in different sections of the page (and the grid's panel link
 * can navigate to /#calculator), so the last request is also stashed and
 * handed to the calculator when it mounts.
 *
 * Request shape: { account: string, seats: number, source: "cell" | "panel",
 *                  lines: [{ sku, quantity, module }] }
 */
let pending = null;
const subs = new Set();

export function requestQuote(req) {
  pending = req;
  subs.forEach((cb) => cb(req));
  // Bring the calculator into view; it is on the same page on Home.
  const el = document.getElementById("calculator");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function onQuote(cb) {
  subs.add(cb);
  if (pending) cb(pending);
  return () => subs.delete(cb);
}

export function clearQuote() { pending = null; }
